module.exports = __webpack_public_path__ + "static/lifts_show_relevance-ce35bf0e8fba5e1dbee6534ea1b51436.png";